import { useStoreContext } from "@components/store/provider";

import ScrollDepthTracker from "@sharedComponents/scroll-depth-tracker";

import { ANALYTICS_TARGET_LISTING } from "@constants/analytics/filter";

/**
 * Product listing scroll milestones (25/50/75/100%). Delegates to shared ScrollDepthTracker.
 */
const ListingScrollTracker = ({ children, baseEventProperties }) => {
  const { storeNumber } = useStoreContext();

  if (!storeNumber) {
    return children || null;
  }

  return (
    <ScrollDepthTracker
      key={`${storeNumber}-${String(baseEventProperties?.category_id)}-${String(
        baseEventProperties?.subcategory_id,
      )}`}
      eventProperties={baseEventProperties}
      analyticsTarget={ANALYTICS_TARGET_LISTING}
    >
      {children}
    </ScrollDepthTracker>
  );
};

export default ListingScrollTracker;
